<script lang="ts">
import { defineComponent } from 'vue';
import { BetSlipResultStatus } from 'shared-types';
import { BetSlipRejectStatus } from '@/types/coupons.enum';
import { formatCurrency, formatMoney } from '@/utils/format';

export default defineComponent({
  name: 'row-outcome',
  computed: {
    BetSlipResultStatus() {
      return BetSlipResultStatus;
    },
    BetSlipRejectStatus() {
      return BetSlipRejectStatus;
    },
    won() {
      return this.stake.status === BetSlipResultStatus.Won;
    },
    lost() {
      return this.stake.status === BetSlipResultStatus.Lost;
    },
    voided() {
      return this.stake.status === BetSlipResultStatus.Voided && +this.stake.payout === 0;
    },
    cashedOut() {
      return this.stake.status === BetSlipResultStatus.Voided && +this.stake.payout !== 0;
    },
    rejected() {
      return this.stake.rejectStatus === BetSlipRejectStatus.Rejected;
    },
  },
  data() {
    return {
      decimals: 2,
    };
  },
  methods: { formatMoney, formatCurrency },
  props: ['stake'],
});
</script>

<template>
  <span class="result">Результат</span>
  <span class="result">
    <template v-if="won">
      <span class="won">Выигрыш</span>
    </template>

    <span v-else-if="rejected" class="rejected"> Не расчитывается </span>

    <span v-else-if="lost" class="lost"> Проигрыш </span>

    <span v-else-if="cashedOut" class="voided"> Кешаут {{ stake.amount }}</span>

    <span v-else-if="voided" class="voided"> Возврат </span>

    <span v-else class="waiting"> Ожидаем </span>

    <span v-if="rejected && stake.refund" class="voided"> Возврат </span>
  </span>
  <div class="result relative py-1">
    <div v-if="rejected" v-for="(rd, i) in stake.rejectionData" class="text-sm font-normal">
      <div>{{ rd.reasonCode }}</div>
      <div class="text-gray-500">{{ rd.reasonMessage }}</div>
    </div>

    <template v-else-if="won">
      <span class="won">
        {{ formatMoney(stake.payout, decimals) }}
      </span>
      {{ formatCurrency(stake.payout, stake.currency) }}
      <i class="pi pi-minus mx-2" />
      <span class="won">
        {{ formatMoney((stake.payout * stake.vendorStakeAmount) / stake.stakeAmount, decimals, false) }}
      </span>
      {{ stake.vendorCurrency }}
    </template>

    <template v-if="voided || +stake.refund">
      <span class="voided">{{ formatMoney(stake.refund, decimals) }}</span>
      {{ formatCurrency(stake.refund, stake.currency) }}
      <i class="pi pi-minus mx-2" />
      <span class="voided">{{
        formatMoney((stake.refund * stake.vendorStakeAmount) / stake.stakeAmount, decimals, false)
      }}</span>
      {{ stake.vendorCurrency }}
    </template>

    <template v-if="cashedOut">
      <span class="voided">{{ formatMoney(stake.payout, decimals) }}</span>
      {{ formatCurrency(stake.payout, stake.currency) }}
      <i class="pi pi-minus mx-2" />
      <span class="voided">{{
        formatMoney((stake.payout * stake.vendorStakeAmount) / stake.stakeAmount, decimals, false)
      }}</span>
      {{ stake.vendorCurrency }}
    </template>

    <template v-else-if="stake.status === BetSlipResultStatus.Lost">
      <span class="lost">{{ formatMoney(stake.stakeAmount, decimals) }}</span>
      {{ formatCurrency(stake.stakeAmount, stake.currency) }}
      <i class="pi pi-minus mx-2" />
      <span class="lost">{{
        formatMoney(stake.vendorStakeAmount, decimals, false)
      }}</span>
      {{ stake.vendorCurrency }}
    </template>

    <span class="absolute right-0 mr-2 cursor-pointer">
      <i
        :class="{
          'pi': true,
          'pi-angle-double-right': decimals === 2,
          'pi-angle-double-left': decimals !== 2,
        }"
        @click="decimals = decimals === 2 ? 4 : 2"
      />
    </span>
  </div>
</template>

<style scoped lang="scss">
.result {
  @apply font-bold text-lg bg-gray-300 dark:bg-gray-700;
  .won {
    @apply text-emerald-500 mr-2;
  }

  .lost {
    @apply text-rose-500 mr-2;
  }

  .voided {
    @apply text-yellow-500 mr-2;
  }

  .rejected {
    @apply text-rose-500 mr-2;
  }

  .waiting {
    @apply text-yellow-500;
  }
}
</style>
